"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FormControl = function () {
  function FormControl(touched, errors) {
    if (touched === void 0) {
      touched = false;
    }

    if (errors === void 0) {
      errors = [];
    }

    this.touched = false;
    this.errors = [];
    this.loading = false;
    this.touched = touched;
    this.errors = errors;
  }

  FormControl.prototype.setTouched = function (touched) {
    this.touched = touched;
    return this;
  };

  FormControl.prototype.setErrors = function (errors) {
    this.errors = errors;
    return this;
  };

  FormControl.prototype.setLoading = function (loading) {
    this.loading = loading;
    return this;
  };

  FormControl.prototype.hasError = function () {
    return this.errors.length > 0;
  };

  FormControl.prototype.isLoading = function () {
    return this.loading;
  };

  FormControl.prototype.touchedAndHasError = function () {
    return this.touched && this.hasError();
  };

  FormControl.prototype.untouchedAndHasError = function () {
    return !this.touched && this.hasError();
  };
  /**
   * @deprecated
   */


  FormControl.prototype.touchedAndWithoutError = function () {
    return this.touchedAndNoError();
  };

  FormControl.prototype.touchedAndNoError = function () {
    return this.touched && !this.hasError();
  };
  /**
   * @deprecated
   */


  FormControl.prototype.untouchedAndWithoutError = function () {
    return this.untouchedAndNoError();
  };

  FormControl.prototype.untouchedAndNoError = function () {
    return !this.touched && !this.hasError();
  };

  return FormControl;
}();

exports["default"] = FormControl;